const HexaColor = ({ value }) => {
  return (
    <div
      style={{
        backgroundColor: value,
        width: "100px",
        left: 0,
        right: 0,
        margin: "auto",
        borderRadius: "2em",
      }}
    >
      {value}
    </div>
  );
};

export default HexaColor;
